import propTypes from "prop-types";
import bars from "../assets/bars.svg";

// this is a simple header, getting title string from parent
// long title, short title will set on render once.
const Header = (props) => {


  return (
	<header className="header">
    	<img src={bars} alt="Open Menu" id="openMenuIcon" className="" onMouseUp={props.handleMouseUp}/>
	    <div className="header__title">{window.innerWidth > 770 ? props.longTitle : props.shortTitle}</div>
      	<div className="header__user" style={window.innerWidth > 770 ? {} : { display: "hidden" }}>
      </div>
      </header>
  );
};

// in case nothing is passed in
Header.defaultProps = {
  longTitle: "NEED TITLE (archetype)",
  shortTitle: "BCH App"
};

// set title type to string, and make it required
Header.propTypes = {
  longTitle: propTypes.string.isRequired,
  shortTitle: propTypes.string.isRequired
};

export default Header;
